// extracted by mini-css-extract-plugin
export default {"ssnHeading":"RW7tKOopX82U3yEKz2nh"};